import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

/*
|---------------------------------------------------------------------
|                             Routes
|---------------------------------------------------------------------
*/

import { AuthContext, AuthProvider } from "./contexts/AuthContext";

import AuthLayout from "./layouts/AuthLayout";
import MainLayout from "./layouts/MainLayout";

import Signin from "./pages/auth/Signin";
import Verify from "./pages/auth/Verify";
import Users from "./pages/users/Users";

import Services from "./pages/services/Services";
import Service from "./pages/services/Service";
import Dashboard from "./pages/home/Dashboard";

import Entries from "./pages/entries/Entries";
import Entry from "./pages/entries/Entry";
import Regions from "./pages/regions/Regions";
import Makes from "./pages/makes/Makes";
import Branches from "./pages/branches/Branches";
import Update from "./pages/entries/Update";

function App() {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/signin" element={<Signin />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/" element={<Signin />} />
          </Route>

          <Route element={<MainLayout />}>
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entries"
              element={
                <ProtectedRoute>
                  <Entries />
                </ProtectedRoute>
              }
            />

            <Route
              path="/entries/new"
              element={
                <ProtectedRoute>
                  <Entry />
                </ProtectedRoute>
              }
            />
            <Route
              path="/entries/:id/update"
              element={
                <ProtectedRoute>
                  <Update />
                </ProtectedRoute>
              }
            />
            <Route
              path="/services"
              element={
                <ProtectedRoute>
                  <Services />
                </ProtectedRoute>
              }
            />

            <Route
              path="/records/:id"
              element={
                <ProtectedRoute>
                  <Service />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/regions"
              element={
                <ProtectedRoute>
                  <Regions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/makes"
              element={
                <ProtectedRoute>
                  <Makes />
                </ProtectedRoute>
              }
            />

            <Route
              path="/branches"
              element={
                <ProtectedRoute>
                  <Branches />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Signin />} />
        </Routes>
      </AuthProvider>
    </QueryClientProvider>
  );
}

function ProtectedRoute({ children }: { children: JSX.Element }) {
  let { token } = React.useContext(AuthContext);
  let location = useLocation();
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

export default App;
